"use client";

import { AppErrorScreen } from "@/components/system/AppErrorScreen";

import "./globals.css";

/**
 * Última red: sólo se usa cuando el que falla es el LAYOUT RAÍZ, y por eso
 * tiene que traer su propio `<html>`/`<body>` — reemplaza el documento entero,
 * sin providers de tema ni fuentes. De ahí que `AppErrorScreen` lleve los
 * colores explícitos en vez de tokens.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="es">
      <body>
        <AppErrorScreen error={error} reset={reset} />
      </body>
    </html>
  );
}
